import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { FsFormatDatePipe } from '@lib/common/pipes';

import { FsAxonDeviceAdvancedMarker } from '../axon-device-marker/axon-device-marker';

@Component({
  selector: 'fs-axon-notification-details',
  templateUrl: './axon-notification-details.component.html',
  styleUrls: ['./axon-notification-details.component.scss'],
})
export class AxonNotificationDetailsComponent {
  @Input()
  public content: FsAxonDeviceAdvancedMarker;

  constructor(private readonly _sanitizer: DomSanitizer) {}

  public formatDate(date: number): string {
    return `${new FsFormatDatePipe().transform(date, 'HH:mm')}hrs`;
  }

  public safeHTML(value: any): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}
